import api from "@/api/axios";

const historialDeOfertasModel = {
  data: {},
  async obtenerOfertasUsuario(tipo, { page = 1, subasta_external_id = null } = {}) {
    try {
      const params = { page: Number(page) || 1 };
      if (subasta_external_id) params.subasta_external_id = subasta_external_id;

      const { data } = await api.get(`pujas/ofertas/historial/${tipo}`, {
        params,
      });
      return data;
    } catch (error) {
      console.error("Error al obtener el lote:", error);
      throw error;
    }
  },
  async asignarIdPerfilFacturacionALote(idLote, idFacturacion) {
    try {
      const response = await api.post(
        `lotes/${idLote}/facturacion/${idFacturacion}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener el lote:", error);
      throw error;
    }
  },

  async asignarIdPerfilFacturacionALoteMasivo(pujas, perfilFacturacion) {
    try {
      let params = {
        pujas: pujas,
        perfil_facturacion: perfilFacturacion,
      };
      const response = await api.post(`lotes/facturacion/masivo`, params);
      return response.data;
    } catch (error) {
      console.error("Error al obtener el lote:", error);
      throw error;
    }
  },
};

export default historialDeOfertasModel;
